import { Trip } from './../classes.js';

export function trip_title__element(data, edit = false){
	let $content = '';
	let $read = '';
	let $as_label = '';
	let $as_input = '';
	
	//create the trip title element // edit or read
	if(edit){ 
		$content = $('<div/>', {
			'class': 'editable form__row',
			'data-el_id': 'name',
			'data-block_id': 'trip'
		});
		
		$as_label = $('<label/>', {
			'for': 'trip-header',
			'text': 'Trip Name'
		});
		
		$as_input = $('<input/>', {
			'type': 'text',
			'name': 'name',
			'id': 'trip-header',
			'autocomplete': 'jb-trip-name',
			'class': 'editable--H1',
			'value': data.name
		});
		
		$content.append($as_label, $as_input);
	}else{
		$content = $('<h1/>', {
			'class': 'branded editor',
			'text': data.name == '' ? 'Create a New Trip' : data.name,
			'data-el_id': 'name',
			'data-block_id': 'trip'
		});
		
		$as_input = $('<input/>', {
			'type': 'hidden',
			'name': 'name',
			'value': data.name == '' ? 'Create a New Trip' : data.name
		});
		
		$content.append($as_input);
		
	}
	
	return $content;
}